import React, { useContext, useEffect, useState } from 'react';
import { ShopContext } from '../context/ShopContext';
import Title from './Title';
import ProductItem from './ProductItem';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Sweatshirts = () => {
    const { products } = useContext(ShopContext);
    const [sweatshirts, setSweatshirts] = useState([]);
    const dynamicKeywords = sweatshirts.map(item => item.name).join(', ');

    useEffect(() => {
        const filteredProducts = products.filter(product => product.category === 'Sweatshirts');
        setSweatshirts(filteredProducts.slice(0, 4));
    }, [products]);

    return (

        <>
        {/* SEO Metadata */}
        <Helmet>
            <title>Stylish Sweatshirts Collection - Comfortable and Trendy</title>
            <meta
                name="description"
                content="Discover our stylish and comfortable sweatshirts for every occasion. Perfect for a casual day out or cozy evenings."
            />
            <meta
                name="keywords"
                content={`sweatshirts, stylish sweatshirts, comfortable sweatshirts, trendy sweatshirts, casual wear, sweatshirt collection, ${dynamicKeywords}`}
            />
        </Helmet>

        <div className='my-10 bg-[#e0e0e0]'>
            <div className='text-center py-8 text-3xl'>
                <Title text1={'SWEATSHIRTS'} text2={'COLLECTION'} />
                {/* <p className='w-3/4 m-auto text-xs sm:text-sm md:text-base text-gray-600'>
                    Discover our stylish and comfortable sweatshirts for every occasion.
                </p> */}
            </div>

            <div className='max-w-screen-xl mx-auto px-4'>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 gap-y-6">
                    {sweatshirts.map((item, index) => (
                        <ProductItem key={index} id={item._id} image={item.image} name={item.name} price={item.price} op={item.originalPrice}/>
                    ))}
                </div>
                <div className="text-center mt-8">
                    <Link to="/collection" className="text-white bg-orange-500 px-6 py-2 rounded-lg hover:bg-orange-600" >
                        See All
                    </Link>
                </div>
            </div>
        </div>
        </>
    );
};

export default Sweatshirts;

// onClick={() => window.scrollTo(0, 0)}
